import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

if (document.querySelector(".p-home-about")) {
  // 画像をclip-pathで表示させるアニメーション
  const images = gsap.utils.toArray([
    ".p-home-about__image-01",
    ".p-home-about__image-02",
    ".p-home-about__image-03",
  ]);

  gsap.to(images, {
    clipPath: "inset(0% 0% 0% 0%)",
    stagger: 0.2,
    duration: 1.2,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".p-home-about__image",
      start: "top 90%",
      end: "bottom bottom",
      scrub: true, // スクロールに追従させる
    },
  });

  // .p-home-about__image-* 内の img, video 要素をスケールアニメーション
  const mediaElements = gsap.utils.toArray([
    ".p-home-about__image-01 img, .p-home-about__image-01 video",
    ".p-home-about__image-02 img, .p-home-about__image-02 video",
    ".p-home-about__image-03 img, .p-home-about__image-03 video",
  ]);

  gsap.from(mediaElements, {
    scale: 1.2,
    scrollTrigger: {
      trigger: ".p-home-about__image",
      start: "top 90%",
      scrub: true,
    },
  });

  // .p-home-about__image-01 内の画像/動画に対するパララックス効果
  gsap.fromTo(
    ".p-home-about__image-01",
    { y: "-10%" }, // 初期位置（少し上に）
    {
      y: "10%", // 終了位置（少し下に）
      ease: "none",
      scrollTrigger: {
        trigger: ".p-home-about__image", // アニメーションのトリガーとなる要素
        start: "top bottom", // トリガー要素が画面下部にきたら開始
        end: "bottom top", // トリガー要素が画面上部を抜けたら終了
        scrub: true, // スクロールに追従させる
      },
    }
  );

  // .p-home-about を通過する際に body の背景色を黒に変更し、通過後に元に戻す
  const bgTl = gsap.timeline({
    scrollTrigger: {
      trigger: ".p-home-about",
      start: "top 70%",
      end: "bottom bottom",
      scrub: true,
    },
  });

  bgTl
    .to("body", { background: "#000000", ease: "none" }, 0)
    .to("body", { background: "#ffffff", ease: "none" }, 1);

  // .p-home-about が表示されたらヘッダーの文字色を白に変更
  ScrollTrigger.create({
    trigger: ".p-home-about",
    start: "top 10%", // ヘッダーの高さ分くらいを考慮
    end: "bottom 10%",
    toggleClass: { targets: ".l-header", className: "l-header--white" },
  });

  // .p-home-about__image-01 内の画像/動画に対するパララックス効果
  gsap.fromTo(
    ".p-home-about__image-01",
    { y: "-30%" }, // 初期位置
    {
      y: "15%", // 終了位置
      ease: "none",
      scrollTrigger: {
        trigger: ".p-home-about__image",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    }
  );
  // .p-home-about__image-02 内の画像/動画に対するパララックス効果
  gsap.fromTo(
    ".p-home-about__image-02",
    { y: "-15%" }, // 初期位置
    {
      y: "15%", // 終了位置
      ease: "none",
      scrollTrigger: {
        trigger: ".p-home-about__image",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    }
  );

  // .p-home-about__image-03 内の画像/動画に対するパララックス効果
  gsap.fromTo(
    ".p-home-about__image-03",
    { y: "-30%" }, // 初期位置
    {
      y: "20%", // 終了位置
      ease: "none",
      scrollTrigger: {
        trigger: ".p-home-about__image",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    }
  );
}
